/**
 * A régua do painel (docs/PLANO_CONTAGEM_PRAZOS.md, Bloco F): quantos prazos vencem
 * em cada dia das próximas duas semanas, os de hoje e os vencidos da semana.
 */
import { api, type Processo } from './client';

/** Um dia da régua. `conta: false` é vão (fim de semana, feriado), com o motivo. */
export interface DiaDaRegua {
  data: string;
  conta: boolean;
  motivo: string | null;
  /** Intimações que vencem no dia. */
  prazos: number;
  /** Processos dessas intimações (um processo pode ter duas no mesmo dia). */
  processos: number;
  estimados: number;
  /** Onde o dia não conta, quando conta em outro lugar do acervo. */
  ressalvas: string[];
}

export interface Regua {
  hoje: string;
  dias: DiaDaRegua[];
  hoje_prazos: number;
  hoje_processos: number;
  processos_na_janela: number;
  vencidos_desde: string;
  vencidos_prazos: number;
  vencidos_processos: number;
}

export async function fetchRegua(): Promise<Regua> {
  const { data } = await api.get<Regua>('/prazos/regua');
  return data;
}

/** O acervo de quem tem intimação vencendo entre as duas datas (filtro no servidor). */
export async function fetchProcessosPorVencimento(de: string, ate: string): Promise<Processo[]> {
  const { data } = await api.get<{ items: Processo[] }>('/processos', { params: { vence_de: de, vence_ate: ate } });
  return data.items;
}
